export class Client {
  public id: number
  public name: string
  public email: string
  public phone: string
  public tax: string
  public address: string
  public picture: string
  public updated: boolean


  constructor(client:any = {}) {
    this.id = client.id || null
    this.name = client.name || ""
    this.email = client.email || ""
    this.phone = client.phone || ""
    this.picture = client.picture || ""
    this.tax = client.tax || ""
    this.address = client.address || ""
    this.updated = true
  }
}



// WEBPACK FOOTER //
// ./src/_models/Client.tsx